import React, {useContext} from 'react';

import Chat from 'components/Chat/Chat';
import Context from 'utils/Context';
import {useChat} from 'hooks';

const ChatPane = ({event}) => {
  const {appState} = useContext(Context);
  const {messages, handleMessageSend} = useChat(event.id);

  return (
    <div className="multiplex-chat-container">
      <Chat
        pseudo={appState.user.pseudo}
        onSend={handleMessageSend}
        messages={messages}
        // notFull
        visible
      />
    </div>
  );
};

export default ChatPane;
